import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from "@angular/core";
import { UtilsService } from "src/app/core/services/utils.service";
import { IUploadedDocument } from "../documents.models";

@Component({
  selector: "app-proof-residence",
  templateUrl: "./proof-residence.component.html",
  styleUrls: ["./proof-residence.component.scss"],
})
export class ProofResidenceComponent implements OnChanges {
  documentFile: any;
  documentFileExtension: any;

  @Input() addressProofDocument;
  @Input() addressProofDocumentExtension;
  @Input() isExhibition = false;
  @Input() isConsult = false;

  @Output() downloadEvent: EventEmitter<IUploadedDocument> = new EventEmitter();
  @Output() formValue: EventEmitter<any> = new EventEmitter();
  sasUrl: string;

  constructor(private utilsService: UtilsService) { }

  ngOnChanges(changes: SimpleChanges): void {
    this.loadData(changes);
  }

  loadData(changes: SimpleChanges) {
    const data = changes.addressProofDocument?.currentValue;

    if (data) {
      this.sasUrl = `${data}`;
      this.documentFileExtension = `${changes.addressProofDocumentExtension?.currentValue}`;
    }
  }

  emitFormProofResidenceValue() {
    if (!this.documentFile) {
      return;
    }

    const formProofResidenceValue = {
      documentFile: this.documentFile,
      documentFileExtension: this.documentFileExtension,
    };

    this.formValue.emit(formProofResidenceValue);
  }

  getDocumentFile(event) {
    this.documentFile = event.base64;
    this.documentFileExtension = event.extension;
  }

  downloadFile() {
    if (this.sasUrl)
      this.downloadEvent.emit({
        extension: this.documentFileExtension,
        sasUrl: this.sasUrl,
        fileName: `COMPROVANTE_RESIDENCIA.${this.documentFileExtension}`,
      });

    if (this.documentFile && this.documentFile !== "null")
      this.utilsService.downloadFile(
        this.documentFile,
        `COMPROVANTE_RESIDENCIA.${this.documentFileExtension}`
      );
  }
}
